import { render, staticRenderFns } from "./ksExpireRemindRegionPage.vue?vue&type=template&id=3580452d&scoped=true&"
import script from "./ksExpireRemindRegionPage.vue?vue&type=script&lang=js&"
export * from "./ksExpireRemindRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./ksExpireRemindRegionPage.vue?vue&type=style&index=0&id=3580452d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580452d",
  null
  
)

export default component.exports